/* Global imports. */
import React from "react";
import { nanoid } from 'nanoid';

/* Component imports. */
import Banner from "@components/Banner"

/* Model imports. */
import KontentBanner from "@models/kontent/KontentBanner"

interface Props {
  banners: [KontentBanner];
}

const BannerCollection = ({ banners }: Props) => {

  const bannerCollection = banners.banners.value;

  return (
    <section className="grid grid-cols-12 gap-x-4 pm-content-module">
      {bannerCollection.map((item:any) => {
          const banner = item.elements;
          const styling = banner.styling.value[0] && banner.styling.value[0].elements
          const primaryTextColor = styling && styling.primary_colour.value ? styling.primary_colour.value :  ``
          const backgroundColour = styling && styling.background_colour.value ? styling.background_colour.value : ``
          
          return <Banner 
            key={nanoid()}
            title={banner.title.value} 
            text={banner.text.value} 
            buttonText={banner.button_text && banner.button_text.value} 
            buttonUrl={banner.button_url && banner.button_url.value}
            imageUrl={banner.background_image && banner.background_image.value && banner.background_image.value[0] && banner.background_image.value[0].url}
            textPlacementClass={banner.text_placement && banner.text_placement.value && banner.text_placement.value[0] ? `banner_text_${banner.text_placement.value[0].codename}` : `banner_text_left`}
            primaryTextColour={primaryTextColor}
            backgroundColour={styling && styling.background_colour.value ? styling.background_colour.value : `` }
            backgroundColourLeft={banner.background_colour_left && banner.background_colour_left.value ? banner.background_colour_left.value : backgroundColour && backgroundColour != "#CCCCCC" ? backgroundColour : `transparent`}
            backgroundColourRight={banner.background_colour_right && banner.background_colour_right.value ? banner.background_colour_right.value : backgroundColour && backgroundColour != "#CCCCCC" ? backgroundColour : `transparent`}
            isPageHero={banner.page_hero && banner.page_hero.value && banner.page_hero.value[0] && banner.page_hero.value[0].codename === "yes" ? true : false}
            bannerWidth={banner.width && banner.width.value && banner.width.value[0] && banner.width.value[0].codename}
            bannerType={banner.type && banner.type.value && banner.type.value[0] ? banner.type.value[0].codename : "background_image"}
            imagePlacement={banner.background_image_placement && banner.background_image_placement.value && banner.background_image_placement.value[0] ? banner.background_image_placement.value[0].codename : 'left'}
            bannerCollectionLengh={bannerCollection.length}
            />
      })} 
    </section>
  )
};

export default BannerCollection;